var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	6308: {
		fallback: () => (() => (__webpack_require__(8485))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	5590: {
		fallback: () => (() => (__webpack_require__(7552))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	8263: {
		fallback: () => (() => (__webpack_require__(6876))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@omiexperience/orbi-ui",

	},
	9954: {
		fallback: () => (() => (__webpack_require__(4510))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.61.5",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	2273: {
		fallback: () => (() => (__webpack_require__(9752))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.18.3",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-router",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [6308,5590,6308,5590];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"151": [
		8263,
		9954,
		2273
	],
	"792": [
		6308,
		5590
	],
	"869": [
		6308,
		5590
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}